import { FormStatus } from '../../../../utils/state/initialStateFactory';
import { CreateActionParams } from '../actions';
import { bookingsBookingsFormLoad } from '@wix/bi-logger-wixboost-ugc/v2';

export type InitializeWidget = () => void;

export function createInitializeWidgetAction({
  getControllerState,
  context: { biLogger },
}: CreateActionParams): InitializeWidget {
  return () => {
    const [state, setState] = getControllerState();
    biLogger?.report(
      bookingsBookingsFormLoad({
        formId: state.service.formSchema.formId,
      }),
    );
    setState({
      status: FormStatus.IDLE,
    });
  };
}
